export default __webpack_public_path__ + "5542984205f704bb3b34124c19638f2e.png";